import { Component, OnInit } from '@angular/core';
import { AccessSections } from 'src/app/classes/user';
import { SharedService } from 'src/app/services/shared.service';
import { UserService } from 'src/app/services/user.service';
import { skip } from 'rxjs/operators';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  subscription: any;
  pathList: Array<Array<string>>;
  bcRightValue: Array<Array<number>>;
  busy: Promise<any>;
  access_sections$: AccessSections

  constructor(public userService: UserService, private sharedService: SharedService) {
    this.pathList = [['Home', 'dashboard']];
  }



  ngOnInit(): void {
    console.log("dashboard init")
    this.sharedService.getAccess().subscribe(value => {
        this.access_sections$ = value;
    });
    console.log(this.access_sections$)

  }
}
